import { render, staticRenderFns } from "./TheA.vue?vue&type=template&id=dc19ed92"
import script from "./TheA.vue?vue&type=script&lang=ts"
export * from "./TheA.vue?vue&type=script&lang=ts"
import style0 from "./TheA.vue?vue&type=style&index=0&id=dc19ed92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports